// English strings for the owner WhatsApp alerts setting (Stage 3). One table
// so an Urdu one can be dropped in later.
export const AL = {
  title: 'Kitchen alerts on WhatsApp',
  help: 'Messages to your own staff numbers when something goes wrong between the kitchen, the store and suppliers, plus a morning summary of yesterday.',
  metaWarning: 'Leave this off until the two message templates are approved by Meta (see WA_TEMPLATE_SUBMISSION). Messages sent before then fail.',
  enabled: 'Send kitchen alerts',
  recipients: 'Who gets them',
  recipientsHelp: 'Staff WhatsApp numbers — never customers. Up to 10.',
  label: 'Name',
  phone: 'WhatsApp number',
  add: 'Add a number',
  remove: 'Remove',
  badPhone: 'Not a WhatsApp number',
  rules: 'What to alert on',
  ruleNames: {
    req_short: 'Stock arrived short at the kitchen',
    transit_variance: 'Stock lost in transit written off',
    avt: 'Kitchen used more than expected',
    price_jump: 'A supplier price jumped',
    expiring: 'Stock about to expire',
    po_overdue: 'A supplier order is late',
    equipment_out: 'Equipment not back after an event',
  } as Record<string, string>,
  thresholds: 'Limits',
  avtPct: 'Kitchen usage above expected by more than (%)',
  priceJumpPct: 'Price up by more than (%)',
  expiryDays: 'Expiring within (days)',
  overduePoDays: 'Order late by more than (days)',
  digest: 'Morning summary of yesterday',
  digestHour: 'Send at (hour, 0–23)',
  save: 'Save',
  saved: 'Kitchen alerts saved',
  saveFailed: 'Kitchen alerts were not saved',
  numberMissing: 'Enter a number',
  numberRange: (min: number, max: number) => `Must be from ${min} to ${max}`,
  numberWhole: 'Use a whole number',
  fixNumbers: 'Fix the numbers marked in red before saving.',
  needNumber: 'Add at least one number before switching alerts on.',
  preview: 'What the messages look like',
}
